import { render } from "./PublishWare.vue?vue&type=template&id=555021d4"
import script from "./PublishWare.vue?vue&type=script&lang=js"
export * from "./PublishWare.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__